import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Paper, useTheme } from '@mui/material';
import { FC, useEffect, useMemo } from 'react';
import { GoPlus } from "react-icons/go";
import { useNavigate } from 'react-router-dom';
import { Can } from '../../../Components/Can';
import { Button } from '../../../Components/Form/Button/button.scomponent';
import { ButtonActionMenu } from '../../../Components/Form/ButtonActionsMenu/button-action-menu.component';
import { Loader } from '../../../Components/Loader';
import { Placeholder } from '../../../Components/Placeholder/placeholder.component';
import { Table } from '../../../Components/Table/table.component';
import { BaseContentPage } from '../../../Components/Templates/BaseContentPage/base-content-page.componen';
import { BaseScreen } from '../../../Components/Templates/BaseScreen/basescreen.component';
import { ListSellersUseCase } from '../../../Usecase/Sellers/list-sellers-usecase';
import { useListSellers } from './sellers-list.hook';

interface ISellersList {
    listSellersUseCase: ListSellersUseCase
}
const SellersList : FC<ISellersList> = ({ listSellersUseCase }) => {
    const theme = useTheme()
    const navigate = useNavigate()

    const { listSellers, list, data, loading, sellerToDestroy, setSellerToDestroy, } = useListSellers({
        listSellersUseCase
    })



    useEffect(() => {
      listSellers({ page: 1})
  }, [])


    const columns = useMemo(() => {
        const createColumns: any[] = [
         
          {
            field: 'name',
            headerName: 'Nome',
            flex: 1
          },
          {
            field: 'email',
            headerName: 'E-mail',
            flex: 1
          },
          {
            field: "actions",
            headerName: "Ações",
            headerAlign: "left",
            width: 100, 
            renderCell: (params: any) => <ButtonActionMenu options={[
              {
                title: 'Editar',
                onClick: () => navigate(`/sellers-form/${params.row.id}`),
                icon: <EditIcon fontSize="small" style={{ marginRight: 8, marginTop: '5px' }} />,
              
              },
              {
                title: 'Excluir',
                onClick: () => setSellerToDestroy(params.row),
                icon: <DeleteIcon fontSize="small" style={{ marginRight: 1, marginTop: '5px' }} />,
                titleColor: theme.palette.error.main.toString()
              }
              
              
            ]} />
          }
        ];
      
        return createColumns;
      }, []);
   

    return (
      <Can permissions={['menu:sellers:manage']}>  
        <BaseScreen>
            <Paper >
              {loading && <Loader />}
                <BaseContentPage 
                    title='Vendedores'
                    breadcrumb={[{ title: 'Vendedores', link: "/sellers-list"}, { title: 'Listagem'}]}
                    Action={() => <Button LeftIcon={() => <GoPlus size={18} />} sx={{ width: '130px'}} boxLeftSx={{ gap: '10px', marginLeft: '5px'}} textSx={{ textTransform: 'Capitalize', fontWeight: 500}} onClick={() => navigate('/sellers-form')}>Adicionar</Button>}
                >
                  {!!list?.length ? <Table data={list} columns={columns} totalCount={0} /> : <Placeholder description='Nenhum dado encontrado.' /> }
                </BaseContentPage>
              
            </Paper>
                
        </BaseScreen>
        </Can>
    )
}

export { SellersList };
